import DashboardStatsVisits from "./DashboardVisitsStat";
const DashboardStatsVisitPage=()=>{
    return(
        <DashboardStatsVisits />
    )
}
export default DashboardStatsVisitPage;